module.exports = __webpack_public_path__ + "img/gestoIdeia.1fcbe11c.png";